import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './styles/premium-global.css';
import './styles/curriculum-premium.css';
import './styles/launch-event-premium.css';
import './styles/responsive-utils.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { RegistrationProvider } from "./Contextapi/RegistrationContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RegistrationProvider>
    <App />
    </RegistrationProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
